/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSellerItemTileCarousel_viewer = {
    readonly sellerItems: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly ecommerceTrackingParams: unknown | null;
                readonly categoryPath: string | null;
                readonly categoryCode: string | null;
                readonly serviceId: string | null;
                readonly browseUrl: string | null;
                readonly title: string | null;
                readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_item">;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpRespSellerItemTileCarousel_viewer";
};
export type PdpRespSellerItemTileCarousel_viewer$data = PdpRespSellerItemTileCarousel_viewer;
export type PdpRespSellerItemTileCarousel_viewer$key = {
    readonly " $data"?: PdpRespSellerItemTileCarousel_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSellerItemTileCarousel_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 6,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": [
          "sellerItems"
        ]
      }
    ]
  },
  "name": "PdpRespSellerItemTileCarousel_viewer",
  "selections": [
    {
      "alias": "sellerItems",
      "args": null,
      "concreteType": "moreLikeThisItemConnection",
      "kind": "LinkedField",
      "name": "__PdpRespSellerItemTileCarousel_sellerItems_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "moreLikeThisItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "ecommerceTrackingParams",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "categoryPath",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "categoryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "browseUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSimilarItem_item"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '531e37521943e40dcf215e3d1db0665c';
export default node;
